module.exports = __webpack_public_path__ + "static/media/Figure5.c5f0affa.jpg";